module.exports = __webpack_public_path__ + "static/img/sqjf.ee5142f7.png";